export const SOFTLINE_API_AUTHENTICATION = 'v2/security/authenticate';
export const SOFTLINE_API_SSO = 'v2/security/sso';
